module.exports = __webpack_public_path__ + "static/brasil_mobile-12c792871c7b0f42bb9a2dbd6dfc6e13.webp";